import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Drawer from '../../../../../components/Drawer/Drawer';
import { reset } from '../../../../../stores/AssignDeviceStore';
import { Device } from '../../../../../models/UserDevicesModels';
import AssignSimStep from './AssignSimStep';

interface AssignSimDrawerProps {
  open: boolean;
  onClose: () => void;
  onAssignSimSuccess: () => void;
  device?: Device | null;
}
function AssignSimDrawer({ open, onClose, onAssignSimSuccess, device }: AssignSimDrawerProps) {
  const dispatch = useDispatch();

  /**
   * Handle the close action
   */
  const handleClose = () => {
    dispatch(reset());
    onClose();
  };
  const [t] = useTranslation();

  return (
    <Drawer
      disablePortal
      open={open}
      onClose={handleClose}
      onBackButton={handleClose}
      anchor="right"
      title={t('pages.assignSim.title')}
      progress={100}
    >
      <Box sx={{ paddingTop: '1rem', height: '100%' }}>
        <AssignSimStep onClose={handleClose} onAssignSimSuccess={onAssignSimSuccess} device={device} />
      </Box>
    </Drawer>
  );
}

export default AssignSimDrawer;
